import { Context, createContext, useContext } from 'react'

type Props = {
  apiKey: string
  nonce?: string
}

export const MapContext: Context<Props> = createContext<Props>({
  apiKey: '',
})

export const useMapContext = (): Props => useContext(MapContext)
